/**
 * Calculate total spent on maintenance for an asset
 */
export const calculateMaintenanceTotal = (asset) => {
  if (!asset.maintenanceRecords || asset.maintenanceRecords.length === 0) {
    return 0;
  }
  return asset.maintenanceRecords.reduce((sum, record) => {
    const cost = parseFloat(record.cost) || 0;
    return sum + cost;
  }, 0);
};

/**
 * Calculate total maintenance cost across all assets
 */
export const calculateTotalMaintenanceSpent = (assets) => {
  return assets.reduce((total, asset) => {
    return total + calculateMaintenanceTotal(asset);
  }, 0);
};

